import { graphql, useStaticQuery } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { Link, useI18next } from "gatsby-plugin-react-i18next";
import { isDMM } from "libs/dmm";
import * as React from "react";

const Query = graphql`
    query Copyright {
        terms: markdownRemark(
            frontmatter: {
                type: { eq: "announcement" }
                slug: { eq: "darkwind-service-terms" }
            }
        ) {
            frontmatter {
                slug
            }
        }
        policy: markdownRemark(
            frontmatter: {
                type: { eq: "announcement" }
                slug: { eq: "darkwind-policy" }
            }
        ) {
            frontmatter {
                slug
            }
        }
        announce: markdownRemark(
            frontmatter: {
                type: { eq: "announcement" }
                slug: { eq: "darkwind-announce" }
            }
        ) {
            frontmatter {
                slug
            }
        }
        guidelines: markdownRemark(
            frontmatter: {
                type: { eq: "announcement" }
                slug: { eq: "darkwind-guidelines" }
            }
        ) {
            frontmatter {
                slug
            }
        }
    }
`;

export function Copyright() {
    const { language, t } = useI18next();
    const data = useStaticQuery<Queries.CopyrightQuery>(Query);
    // noinspection AllyJsxHardcodedStringInspection
    return (
        <section className="py-16 text-xs text-center text-primary">
            {language === "zh-tw" && (
                <div>
                    <div className="mx-auto w-[50px] h-[50px] lg:w-[90px] lg:h-[90px]">
                        <StaticImage
                            src="../images/18.png"
                            alt="18+ 限制級"
                            sizes="90px"
                        />
                    </div>
                    <p className="my-12">
                        本遊戲分類為限制級，須滿18歲始得購買或使用。
                        <br />
                        請注意遊戲時間，避免沉迷。遊戲虛擬情節請勿模仿。
                        <br />
                        本遊戲為免費使用，但遊戲部分內容或服務需另行支付其他費用，請依個人興趣、能力進行購買，請勿過度消費。
                        <br />
                        請閱讀、瞭解並同意「使用者服務條款」及「個人資料暨隱私政策條款」之所有內容後，方得使用本遊戲服務。
                    </p>
                </div>
            )}
            <div className="flex justify-between mx-auto w-full max-w-[388px] mb-8 items-center lg:max-w-xl lg:mb-20">
                <div className="w-[29%]">
                    <StaticImage
                        src="../images/pinkcore-logo@2x.png"
                        alt="PINKCORE"
                    />
                </div>
                <div className="w-[52.5%]">
                    <StaticImage
                        src="../images/logo-tss@2x.png"
                        alt="THE SHADOW STUDIO"
                    />
                </div>
            </div>
            <p>
                {isDMM ? (
                    <>
                        <Link to={"/news/" + data.policy?.frontmatter?.slug}>
                            Privacy Policy
                        </Link>
                        {" | "}
                        <Link to={"/news/" + data.terms?.frontmatter?.slug}>
                            Terms of Use
                        </Link>
                    </>
                ) : (
                    <a
                        href={t("policy_link")}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="lg:hover:text-white"
                    >
                        Privacy Policy | Terms of Use
                    </a>
                )}
                {" | "}
                <a
                    href="mailto:ask-riseoferos@pinkcore.com"
                    className="lg:hover:text-white"
                >
                    Contact Us
                </a>
            </p>
            {isDMM && (
                <p className="mt-1">
                    <Link to={"/news/" + data.announce?.frontmatter?.slug}>
                        特定商取引法に基づく表示
                    </Link>
                    {" | "}
                    <Link to={"/news/" + data.guidelines?.frontmatter?.slug}>
                        二次創作ルール
                    </Link>
                </p>
            )}
            <p className="mt-3">©2022-2025 The Shadow Studio / Rise of Eros™</p>
        </section>
    );
}
